import { Endpoints } from '../../../common/model/config';

export const eldoradoEndpoints: Endpoints = {
  api: 'https://onyo-api.shoppingeldorado.com.br/',
  graphql: 'https://onyo-graphql.shoppingeldorado.com.br/graphql',
  payments: 'https://onyo-payments.shoppingeldorado.com.br/',
  authDomain: 'onyo-auth.shoppingeldorado.com.br',
  enterpriseUserForm: 'https://enterprise-user.shoppingeldorado.com.br/',
};

export const eldoradoStagingEndpoints: Endpoints = {
  api: 'https://onyo-api.staging.shoppingeldorado.com.br/',
  graphql: 'https://onyo-graphql.staging.shoppingeldorado.com.br/graphql',
  payments: 'https://onyo-payments.staging.shoppingeldorado.com.br/',
  authDomain: 'onyo-auth.shoppingeldorado.com.br',
  enterpriseUserForm: 'https://enterprise-user.staging.shoppingeldorado.com.br/',
};
